const map = {
	"./crosscall.png": 1367,
	"./crosscallx4.png": 2875,
	"./nautiz.png": 1246,
	"./pa768.png": 1913,
	"./s52.png": 6361,
	"./samsung.png": 8719,
	"./tdc100.png": 8223
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1436;